import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Carousel } from "react-responsive-carousel";
import { isMobile } from "../../global/helpers";
import { useThemeColors } from "../../Context/Theme";
import "../CSS/Event.css";
import specialOfferImage from "../../Images/speacial-offer.png";
import plusIcon from "../../Images/plus-icon.png";
import CustomButton from "../../components/CustomButton";
import {
  addToCart,
  removeFromCart,
} from "../../Features/services/cartSlice";
import { ADD_TO_CART, REMOVE_FROM_CART } from "../../Api/apiConstant";
import {
  useGetAPIWithoutTokenQuery,
  usePostAddToCartWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../../Api/api";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { logout, showDialog } from "../../Features/services/authSlice";
import Tooltip from "@mui/material/Tooltip";
import { getLoggedIn, getToken, getUserId } from "../../LoginModule/LoginUtility";

function Combo({ eventName }) {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const [combos, setCombos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [quantities, setQuantities] = useState({});
  const userId = getUserId()
  const token = getToken()
  const cartId = sessionStorage.getItem("cartId");
  const eventId = sessionStorage.getItem("event_id");
  const dispatch = useDispatch();
  const isLoggedIn = getLoggedIn();
  const bundleItems = useSelector((state) => state.cart.bundle);
  const cartItems = useSelector((state) => state.cart.items);
  const cart = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const [blankQuantityBundle, setBlankQuantityBundle] = useState([])
  const [selectedBundleQuantity, setSelectedBundleQuantity] = useState([])


  const [AddToCart] = usePostAddToCartWithTokenMutation();
  const [RemoveFromCart] = useRemoveFromCartWithTokenMutation();

  const { data } = useGetAPIWithoutTokenQuery(
    `/api/bundle/readAllBundle?event_id=${eventId}&type=active`, { refetchOnMountOrArgChange: true }
  );

  const handleAddToCart = async (product, value) => {
    const bundleId = product?.bundle_id;
    if (value === "") {
      setBlankQuantityBundle(prev => [...prev, product?.bundle_id])
      handleRemoveFromCart(product, 0)
      return;
    }
    if (value === 0) {
      setBlankQuantityBundle(blankQuantityBundle.filter(n => n !== bundleId))
      handleRemoveFromCart(product, 0)
      return;
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    setBlankQuantityBundle(blankQuantityBundle.filter(n => n !== bundleId))
    if (value) {
      setSelectedBundleQuantity(prev => {
        // Remove any previous entries with the same skuId
        const filtered = prev.filter(item => item.bundleId !== bundleId);
        // Add the new one at the end
        return [...filtered, { bundleId: bundleId, quantity: value }];
      });
    }
    const newCartItem = {
      bundle_id: bundleId,
      quantity: value ? value : 1,
      price: product?.discount_amount,
    };
    const existingCartItem = cartItems?.find(
      (item) => item.bundle_id === newCartItem?.bundle_id
    );

    if (existingCartItem) {
      newCartItem.quantity = value ? value : existingCartItem.bundle_quantity + 1;
    }

    if (isLoggedIn) {
      if (token) {
        // dispatch(addToCart({ ...product, quantity: newCartItem.bundle_quantity }));
        try {
          const { data } = await AddToCart({
            url: ADD_TO_CART,
            formData: {
              user_id: userId,
              items: [newCartItem],
              event_id: eventId,
            },
            token: token,
          });

          if (data.message === "Cart and CartItems processed successfully") {
            sessionStorage.setItem("cartId", data?.cart_id);
          }
        } catch (error) {

        }
      } else {
        dispatch(logout());
        dispatch(showDialog(true));
      }
    } else {
      navigate(`/events/${eventName}/login`);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    const bundleId = product?.bundle_id;
    if (value !== "") {
      setSelectedBundleQuantity(selectedBundleQuantity.filter(n => n.bundleId !== bundleId))
      setBlankQuantityBundle(blankQuantityBundle.filter(i => i !== bundleId))
    }
    const existingCartItem = cartItems?.find(
      (item) => item.bundle_id === bundleId
    );
    if (!existingCartItem) {
      return;
    }
    const newCartItem = {
      bundle_id: bundleId,
      quantity: value ? value : existingCartItem?.bundle_quantity > 1 ? existingCartItem?.bundle_quantity - 1 : 0,
      price: product?.bundle_quantity,
    };

    try {
      if (existingCartItem?.bundle_quantity > 1) {
        const previousQuantity = existingCartItem?.bundle_quantity;
        const newQuantity = previousQuantity - 1;

        // dispatch(removeFromCart({ itemId: bundleId, type: "bundle" }));

        const { data } = await AddToCart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
            callFrom: 'Remove From Bundle'
          },
          token: token,
        });
      } else if (existingCartItem?.bundle_quantity === 1) {
        // dispatch(removeFromCart({ itemId: bundleId, type: "bundle" }));

        const { data } = await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            bundle_id: product?.bundle_id,
            callFrom: 'Remove From Bundle'
          },
          token: token,
        });
      }
    } catch (error) {

    }
  };

  const handlePreOrderNow = (bundleId) => {
    setQuantities((prev) => ({
      ...prev,
      [bundleId]: 1,
    }));
  };

  const handleIncrease = (bundleId) => {
    setQuantities((prev) => ({
      ...prev,
      [bundleId]: (prev[bundleId] || 0) + 1,
    }));
  };

  const handleDecrease = (bundleId) => {
    setQuantities((prev) => ({
      ...prev,
      [bundleId]: Math.max((prev[bundleId] || 1) - 1, 0),
    }));
  };

  const isMob = isMobile()

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prevIndex) => {
  //       const nextIndex = prevIndex + 1;
  //       return nextIndex < data?.data?.length ? nextIndex : 0; // Reset to 0 after last slide
  //     });
  //   }, 5000); // Auto-play every 5 seconds

  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, [data]);

  return (
    <>
      {
        data?.data?.length > 1 ?
          <Carousel
            selectedItem={currentIndex} // Set active slide manually
            showArrows={true}
            showThumbs={false}
            showIndicators={false}
            showStatus={false}
            useKeyboardArrows
            stopOnHover
            onChange={(index) => setCurrentIndex(index)}
            renderArrowPrev={(onClickHandler) => (
              <button
                className="carousel-button prev-button"
                onClick={() => {
                  setCurrentIndex((prev) => Math.max(prev - 1, 0));
                  onClickHandler();
                }}
                title="Previous"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "5vw",
                  transform: "translateY(-50%)",
                  opacity: currentIndex === 0 ? 0.5 : 1,
                  pointerEvents: currentIndex === 0 ? "none" : "auto",
                }}
                disabled={currentIndex === 0}
              >
                &#10094;
              </button>
            )}
            renderArrowNext={(onClickHandler) => (
              <button
                className="carousel-button next-button"
                onClick={() => {
                  setCurrentIndex((prev) =>
                    prev + 1 < data?.data?.length ? prev + 1 : prev
                  );
                  onClickHandler();
                }}
                title="Next"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "5vw",
                  transform: "translateY(-50%)",
                  opacity: currentIndex === data?.data?.length - 1 ? 0.5 : 1,
                  pointerEvents:
                    currentIndex === data?.data?.length - 1 ? "none" : "auto",
                }}
                disabled={currentIndex === data?.data?.length - 1}
              >
                &#10095;
              </button>
            )}
          >
            {data?.data?.length > 0 &&
              data?.data?.map((bundle) => {
                const totalPrice = bundle?.bundleProduct?.reduce(
                  (sum, item) => sum + parseFloat(item?.sku?.regular_price),
                  0
                );
                const filteredBundle = cartItems?.find(
                  (item) => item?.bundle_id === bundle?.bundle_id
                );
                const quantity = blankQuantityBundle?.find(i => i === bundle?.bundle_id) ? "" : selectedBundleQuantity?.find(n => n.bundleId === bundle?.bundle_id) ? selectedBundleQuantity?.find(n => n.bundleId === bundle?.bundle_id)?.quantity : filteredBundle?.bundle_quantity ? filteredBundle?.bundle_quantity : 0;
                return (
                  <div
                    className="fo_css_event_combo"
                    style={{
                      height: isMob ? "80vh" : "60vh",
                      width: "100vw",
                      maxWidth: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        height: isMob ? "70vh" : "50vh",
                        width: "90%",
                        borderRadius: "2em",
                        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
                        position: "relative",
                      }}
                    >
                      <img
                        src={specialOfferImage}
                        alt="Special Offer"
                        style={{
                          width: "220px",
                          height: "50px",
                          zIndex: 10,
                          position: "absolute",
                          right: 0,
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          height: "100%",
                          width: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "hidden",
                        }}
                      >

                        <div
                          style={isMobile()
                            ? {
                              height: "90%",
                              width: "90%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: 'column',
                              marginTop: '50px'
                            }
                            : {
                              height: "90%",
                              width: "90%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                        >
                          <div
                            style={{
                              display: "flex",
                              height: "100%",
                              width: isMob ? "100%" : "80%",
                              justifyContent: "space-around",
                              flexDirection: "column",
                            }}
                          >
                            <p
                              style={{
                                fontSize: fontSizeHeading || "27px",
                                fontWeight: fontWeightHeading || "600",
                                fontFamily: fontFamilyHeading,
                                alignSelf: "flex-start",
                                marginLeft: "1%",
                                marginTop: "2%",
                                marginBottom: "2%",
                                color: textColor,
                              }}
                            >
                              {bundle?.bundle_name}
                            </p>
                            <div
                              style={{
                                display: "flex",
                                height: "100%",
                                width: "100%",
                                overflowX: 'auto',
                                justifyContent: "space-around",
                                alignItems: "center",
                              }}
                            >
                              {bundle?.bundleProduct?.length > 0 &&
                                bundle?.bundleProduct?.map(
                                  (product, index, array) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <div
                                          style={{
                                            height: "100%",
                                            width: isMob ? "40%" : "25%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              height: "70%",
                                              width: "70%",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              borderRadius: "1em",
                                              border: "1px solid #E0E0E0",
                                            }}
                                          >
                                            <img
                                              src={product?.product_img?.product_img}
                                              alt="Main Content"
                                              style={{
                                                height: "5rem",
                                                width: "4.5rem",
                                              }}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              height: "40%",
                                              width: "70%",
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "center",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <Tooltip title={product?.product?.product_name || ""} arrow>

                                              <p
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: fontSize || "0.8rem",
                                                  fontWeight: fontWeight || "500",
                                                  fontFamily,
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  maxWidth: "150px",
                                                }}
                                              >
                                                {product?.product?.product_name}
                                              </p>
                                            </Tooltip>
                                            <p
                                              style={{
                                                marginBottom: "0px",
                                                fontSize: fontSize || "0.6rem",
                                                fontWeight: fontWeight || "600",
                                                fontFamily
                                              }}
                                            >
                                              {" "}
                                              {product?.sku?.unit}
                                            </p>

                                            {product?.sku?.discount_price > 0 && product?.sku?.regular_price !== product?.sku?.discount_price ? (
                                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    fontSize: fontSize || "1rem",
                                                    fontFamily,
                                                    textDecoration: "line-through",
                                                    color: "#888"
                                                  }}
                                                >
                                                  ${product?.sku?.regular_price}
                                                </p>
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    fontSize: fontSize || "1rem",
                                                    fontWeight: fontWeight || "700",
                                                    fontFamily,
                                                    color: "#000"
                                                  }}
                                                >
                                                  ${product?.sku?.discount_price}
                                                </p>
                                              </div>
                                            ) : (
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontSize: fontSize || "1rem",
                                                  fontWeight: fontWeight || "700",
                                                  fontFamily
                                                }}
                                              >
                                                ${product?.sku?.regular_price}
                                              </p>
                                            )}

                                            <p
                                              style={{
                                                marginBottom: "0px",
                                                fontSize: fontSize || "0.8rem",
                                                fontWeight: fontWeight || "700",
                                                fontFamily
                                              }}
                                            >
                                              {" "}
                                              <span>QTY: </span>{product?.bundle_quantity}
                                            </p>
                                          </div>
                                        </div>

                                        {index < array.length - 1 && (
                                          <img
                                            src={plusIcon}
                                            style={{
                                              height: "15%",
                                              width: "auto",
                                              marginBottom: "10%",
                                            }}
                                          />
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                            </div>
                          </div>
                          <div
                            style={{
                              width: isMob ? "45%" : "25%",
                              height: "70%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-around",
                              alignItems: "flex-start",
                            }}
                          >
                            <div
                              style={isMob
                                ? {
                                  fontSize: fontSize || "13.7px",
                                  fontWeight: fontWeight || "600",
                                  textAlign: "left",
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  marginTop: '16px',
                                  fontFamily
                                }
                                : {
                                  fontSize: fontSize || "13.7px",
                                  fontWeight: fontWeight || "600",
                                  textAlign: "left",
                                  fontFamily
                                }}
                            >
                              <span>Total Price:</span>
                              <span
                                style={{
                                  fontSize: fontSize || "18.3px",
                                  fontWeight: fontWeight || "700",
                                  marginLeft: "8px",
                                  fontFamily
                                }}
                              >
                                ${parseFloat(bundle?.discount_amount).toFixed(2)}
                              </span>
                              <span
                                style={{
                                  fontSize: fontSize || "14px",
                                  marginLeft: "8px",
                                  color: "grey",
                                  textDecoration: "line-through",
                                  fontFamily
                                }}
                              >
                                ${parseFloat(bundle?.regular_price).toFixed(2)}
                              </span>
                            </div>

                            {(quantity > 0 || quantity === "") && quantity !== null && quantity !== undefined ? (
                              <div style={styles.quantityContainer}>
                                <button
                                  style={styles.button}
                                  onClick={() => handleRemoveFromCart(bundle)}
                                >
                                  -
                                </button>
                                <input
                                  type="number"
                                  step="1"
                                  min="0"
                                  max="9999"
                                  value={quantity || ""}
                                  style={{ ...styles.input, fontFamily }}
                                  onChange={(e) => {
                                    const val = e.target.value;

                                    if (val === "") {
                                      handleAddToCart(bundle, "");
                                      return;
                                    }

                                    const value = parseInt(val, 10);

                                    if (!isNaN(value) && value >= 0 && value <= 9999) {
                                      handleAddToCart(bundle, value);
                                    }
                                  }}
                                  onFocus={(e) => e.target.select()}
                                  onKeyDown={(e) => {
                                    if (e.key === '.' || e.key === ',' || e.key === 'e') {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <button
                                  style={styles.button}
                                  onClick={() => handleAddToCart(bundle)}
                                >
                                  +
                                </button>
                              </div>
                            ) : (
                              <div style={{ width: isMob ? "100%" : "70%" }}>
                                <CustomButton
                                  text="Pre Order Now"
                                  size="lg"
                                  block={true}
                                  className="my-3"
                                  onClick={() => {
                                    handleAddToCart(bundle);
                                  }}
                                />
                              </div>
                            )}

                            <p
                              style={{
                                fontSize: fontSize || "16px",
                                fontWeight: fontWeight || "400",
                                color: "#555557",
                                width: isMob ? "200px" : '100%',
                                fontFamily,
                                textAlign: 'left'
                              }}
                            >
                              {bundle?.bundle_description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <img
                        src={require("../../Images/red-bg.png")}
                        alt="Background Image"
                        style={{
                          width: "360px",
                          height: "30px",
                          position: "absolute",
                          right: "1.5em",
                          bottom: "-1.9em",
                          zIndex: -10,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
          </Carousel>
          :
          <>
            {data?.data?.length > 0 &&
              data?.data?.map((bundle) => {
                const totalPrice = bundle?.bundleProduct?.reduce(
                  (sum, item) => sum + parseFloat(item?.sku?.regular_price),
                  0
                );
                const filteredBundle = cartItems?.find(
                  (item) => item?.bundle_id === bundle?.bundle_id
                );
                const quantity = blankQuantityBundle?.find(i => i === bundle?.bundle_id) ? "" : selectedBundleQuantity?.find(n => n.bundleId === bundle?.bundle_id) ? selectedBundleQuantity?.find(n => n.bundleId === bundle?.bundle_id)?.quantity : filteredBundle?.bundle_quantity ? filteredBundle?.bundle_quantity : 0;
                return (
                  <div
                    style={{
                      height: isMob ? "80vh" : "60vh",
                      width: "100vw",
                      maxWidth: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        height: isMob ? "70vh" : "50vh",
                        width: "90%",
                        borderRadius: "2em",
                        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
                        position: "relative",
                      }}
                    >
                      <img
                        src={specialOfferImage}
                        alt="Special Offer"
                        style={{
                          width: "220px",
                          height: "50px",
                          zIndex: 10,
                          position: "absolute",
                          right: 0,
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          height: "100%",
                          width: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "hidden",
                        }}
                      >


                        <div
                          style={isMobile()
                            ? {
                              height: "90%",
                              width: "90%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: 'column',
                              marginTop: '50px'
                            }
                            : {
                              height: "90%",
                              width: "90%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                        >
                          <div
                            style={{
                              display: "flex",
                              height: "100%",
                              width: isMob ? "100%" : "80%",
                              justifyContent: "space-around",
                              flexDirection: "column",
                            }}
                          >
                            <p
                              style={{
                                fontSize: fontSizeHeading || "27px",
                                fontWeight: fontWeightHeading || "600",
                                fontFamily: fontFamilyHeading,
                                alignSelf: "flex-start",
                                marginLeft: "1%",
                                marginTop: "2%",
                                marginBottom: "2%",
                                color: textColor,
                              }}
                            >
                              {bundle?.bundle_name}

                            </p>
                            <div
                              style={{
                                display: "flex",
                                height: "100%",
                                width: "100%",
                                overflowX: 'auto',
                                justifyContent: "space-around",
                                alignItems: "center",
                              }}
                            >
                              {bundle?.bundleProduct?.length > 0 &&
                                bundle?.bundleProduct?.map(
                                  (product, index, array) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <div
                                          style={{
                                            height: "100%",
                                            width: isMob ? "40%" : "25%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              height: "70%",
                                              width: "70%",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              borderRadius: "1em",
                                              border: "1px solid #E0E0E0",
                                            }}
                                          >
                                            <img
                                              src={product?.product_img?.product_img}
                                              alt="Main Content"
                                              style={{
                                                height: "5rem",
                                                width: "4.5rem",
                                              }}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              height: "40%",
                                              width: "70%",
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "center",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <Tooltip title={product?.product?.product_name || ""} arrow>
                                              <p
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: fontSize || "0.8rem",
                                                  fontWeight: fontWeight || "500",
                                                  fontFamily,
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  maxWidth: "150px",
                                                }}
                                              >
                                                {product?.product?.product_name}
                                              </p>
                                            </Tooltip>
                                            <p
                                              style={{
                                                marginBottom: "0px",
                                                fontSize: fontSize || "0.6rem",
                                                fontWeight: fontWeight || "600",
                                                fontFamily
                                              }}
                                            >
                                              {" "}
                                              {product?.sku?.unit}
                                            </p>


                                            {product?.sku?.discount_price > 0 && product?.sku?.regular_price !== product?.sku?.discount_price ? (
                                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    fontSize: fontSize || "1rem",
                                                    fontWeight: fontWeight || "700",
                                                    fontFamily,
                                                    color: "#000"
                                                  }}
                                                >
                                                  ${product?.sku?.discount_price}
                                                </p>
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    fontSize: fontSize || "1rem",
                                                    fontFamily,
                                                    textDecoration: "line-through",
                                                    color: "#888"
                                                  }}
                                                >
                                                  ${product?.sku?.regular_price}
                                                </p>
                                              </div>
                                            ) : (
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontSize: fontSize || "1rem",
                                                  fontWeight: fontWeight || "700",
                                                  fontFamily
                                                }}
                                              >
                                                ${product?.sku?.regular_price}
                                              </p>
                                            )}


                                            <p
                                              style={{
                                                marginBottom: "0px",
                                                fontSize: fontSize || "0.8rem",
                                                fontWeight: fontWeight || "700",
                                                fontFamily
                                              }}
                                            >
                                              {" "}
                                              <span>QTY: </span>{product?.bundle_quantity}
                                            </p>
                                          </div>
                                        </div>

                                        {index < array.length - 1 && (
                                          <img
                                            src={plusIcon}
                                            style={{
                                              height: "15%",
                                              width: "auto",
                                              marginBottom: "10%",
                                            }}
                                          />
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                            </div>
                          </div>
                          <div
                            style={{
                              width: isMob ? "45%" : "25%",
                              height: "70%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-around",
                              alignItems: "flex-start",
                            }}
                          >
                            <div
                              style={isMob
                                ? {
                                  fontSize: fontSize || "13.7px",
                                  fontWeight: fontWeight || "600",
                                  textAlign: "left",
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  marginTop: '16px',
                                  fontFamily
                                }
                                : {
                                  fontSize: fontSize || "13.7px",
                                  fontWeight: fontWeight || "600",
                                  textAlign: "left",
                                  fontFamily
                                }}
                            >
                              <span>Total Price:</span>
                              <span
                                style={{
                                  fontSize: fontSize || "18.3px",
                                  fontWeight: fontWeight || "700",
                                  marginLeft: "8px",
                                  fontFamily
                                }}
                              >
                                ${parseFloat(bundle?.discount_amount).toFixed(2)}
                              </span>
                              <span
                                style={{
                                  fontSize: fontSize || "14px",
                                  marginLeft: "8px",
                                  color: "grey",
                                  textDecoration: "line-through",
                                  fontFamily
                                }}
                              >
                                ${parseFloat(bundle?.regular_price).toFixed(2)}
                              </span>
                            </div>

                            {(quantity > 0 || quantity === "") && quantity !== null && quantity !== undefined ? (
                              <div style={styles.quantityContainer}>
                                <button
                                  style={styles.button}
                                  onClick={() => handleRemoveFromCart(bundle)}
                                >
                                  -
                                </button>
                                <input
                                  type="number"
                                  step="1"
                                  min="0"
                                  max="9999"
                                  value={quantity || ""}
                                  style={{ ...styles.input, fontFamily }}
                                  onChange={(e) => {
                                    const val = e.target.value;

                                    if (val === "") {
                                      handleAddToCart(bundle, "");
                                      return;
                                    }

                                    const value = parseInt(val, 10);

                                    if (!isNaN(value) && value >= 0 && value <= 9999) {
                                      handleAddToCart(bundle, value);
                                    }
                                  }}
                                  onFocus={(e) => e.target.select()}
                                  onKeyDown={(e) => {
                                    if (e.key === '.' || e.key === ',' || e.key === 'e') {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <button
                                  style={styles.button}
                                  onClick={() => handleAddToCart(bundle)}
                                >
                                  +
                                </button>
                              </div>
                            ) : (
                              <div style={{ width: isMob ? "100%" : "70%" }}>
                                <CustomButton
                                  text="Pre Order Now"
                                  size="lg"
                                  block={true}
                                  className="my-3"
                                  onClick={() => {
                                    handleAddToCart(bundle);
                                  }}
                                />
                              </div>
                            )}

                            <p
                              style={{
                                fontSize: fontSize || "16px",
                                fontWeight: fontWeight || "400",
                                color: "#555557",
                                width: isMob ? "200px" : '100%',
                                fontFamily,
                                textAlign: 'left'
                              }}
                            >
                              {bundle?.bundle_description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <img
                        src={require("../../Images/red-bg.png")}
                        alt="Background Image"
                        style={{
                          width: "360px",
                          height: "30px",
                          position: "absolute",
                          right: "1.5em",
                          bottom: "-1.9em",
                          zIndex: -10,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
          </>
      }
    </>
  );
}

export default Combo;

const styles = {
  container: {
    borderRadius: "26px",
    border: "1px solid #D9D9D9",
    width: "45%",
    maxWidth: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 10px",
    boxSizing: "border-box",
  },
  button: {
    backgroundColor: "#F6F2F2",
    border: "none",
    borderRadius: "20px",
    width: "20%",
    height: "100%",
    cursor: "pointer",
    fontSize: "18px",
  },
  input: {
    width: "60%",
    textAlign: "center",
    border: "none",
    outline: "none",
    fontSize: "16px",
  },
  quantityContainer: {
    width: "100%",
    disply: "flex",
    border: "1px solid #D9D9D9",
    borderRadius: "1rem",
    height: "7vh",
  },
};
